'use strict';

import { AppContext } from 'plugin/liferay-widgets-react-web';
import { default as ChangeRecordWebApi } from './webApi/ChangeRecordWebApi';
import { default as JournalEntryChangeRecordRenderer } from './components/JournalEntryChangeRecordRenderer';
import { default as ChangeRecordDetailsListRenderer } from './components/ChangeRecordDetailsListRenderer';

export * from './stores/StoreFactory';

AppContext.registerBundle({
    webApis: { ChangeRecordWebApi }
});

export const ChangeRecord = undefined;
export const DetailsRenderer_ChangeRecord = ChangeRecordDetailsListRenderer;
export const JournalRenderer_ChangeRecord = JournalEntryChangeRecordRenderer;


export { default as ChangeRecordActions } from './actions/ChangeRecordActions';
export { default as ChangeRecordListItem } from './components/ChangeRecordListItem';
export { default as ChangeRecordList } from './components/ChangeRecordList';
export { JournalEntryChangeRecordRenderer };

export { ClassNames } from './constants/Constants';



// WEBPACK FOOTER //
// ./js/change-record-portlet.js